import { PROFILE_STATUS, useVerifyProfile } from '@/providers/VerifyProfileProvider';
import { gunterzBold } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { ActionIcon, Box, Image, type MantineBreakpoint, Paper, Stack, Text, rem } from '@mantine/core';
import { IconCircleArrowDown } from '@tabler/icons-react';
export type ProfileCharacterProps = {
  visible?: MantineBreakpoint;
  hidden?: MantineBreakpoint;
};
export const ProfileCharacter: React.FC<ProfileCharacterProps> = ({
  visible,
  hidden
}) => {
  const {
    i18n
  } = useLingui();
  const {
    successes
  } = useVerifyProfile();
  const characterLocked = '/assets/kyc/character-1.png';
  const characterUnlocked = '/assets/kyc/character_armor.png';
  return <Stack align="center" gap={8} visibleFrom={visible} hiddenFrom={hidden}>
      <Image src={successes.has(PROFILE_STATUS.VERIFICATION) ? characterUnlocked : characterLocked} alt="character" w={{
      base: 324,
      sm: 230
    }} />

      {successes.has(PROFILE_STATUS.VERIFICATION) ? <Paper p={{
      base: 10,
      lg: 20
    }} mt={{
      base: 16,
      lg: 30
    }} w="100%" radius={5} bg="transparent" bd="1px solid var(--icon-primary)">
          <Text fz="xs" fw={700} c="var(--text-prime)" tt="uppercase">
            {i18n._('rarity')}
          </Text>
          <Text fz={{
        base: 'sm',
        lg: 'lg'
      }} className={gunterzBold.className}>
            {i18n._('legendary')}
          </Text>

          <Text fz="xs" fw={700} c="var(--text-prime)" tt="uppercase" mt={{
        base: 16,
        lg: 24
      }}>
            {i18n._('rewards')}
          </Text>
          <Text fz={{
        base: 'sm',
        lg: 'lg'
      }} className={gunterzBold.className} style={{
        textWrap: 'nowrap'
      }}>
            {i18n._('250 prll + 5% rakeback')}
          </Text>
        </Paper> : <Stack gap={8} align="center">
          <Box>
            <Text fz={rem(18)} className={gunterzBold.className} c="var(--text-prime)" ta="center">
              {i18n._('COMPLETE ALL STEPS')}
            </Text>
            <Text fz={rem(18)} className={gunterzBold.className} c="var(--text-dark)" ta="center">
              {i18n._('TO UNLOCK ARMOR')}
            </Text>
          </Box>
          <Text fz={rem(12)} c="var(--text-prime)" tt="uppercase">
            {i18n._('(1.3x multiplier)')}
          </Text>
          <ActionIcon variant="transparent">
            <IconCircleArrowDown size={50} color="var(--text-prime)" />
          </ActionIcon>
        </Stack>}
    </Stack>;
};